module.exports = __webpack_public_path__ + "img/vehicle-options-black-honda.af816a27.png";